import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Twitter, Mail, MapPin } from 'lucide-react';

const categories = [
  { name: 'Imigração', slug: 'Imigração' },
  { name: 'Vistos', slug: 'Vistos' },
  { name: 'AIMA', slug: 'AIMA' },
  { name: 'Trabalho', slug: 'Trabalho' },
  { name: 'Custo de Vida', slug: 'Custo de Vida' },
  { name: 'Curiosidades', slug: 'Curiosidades' },
];

export const Footer = () => {
  return (
    <footer className="bg-[#0F5A34] text-white" data-testid="footer">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_visto-portugal/artifacts/1xv4hqe5_Design%20sem%20nome.png" 
                alt="Portugal à Vista" 
                className="h-20 w-auto"
              />
            </div>
            <p className="text-white/80 text-sm font-['Inter'] mb-4">
              O seu portal de informações sobre Portugal. Notícias, guias e recursos para quem quer conhecer ou viver em Portugal.
            </p>
            <div className="flex gap-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#DFAF3A] transition-colors"
                data-testid="social-facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#DFAF3A] transition-colors"
                data-testid="social-instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#DFAF3A] transition-colors"
                data-testid="social-youtube"
              >
                <Youtube size={18} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#DFAF3A] transition-colors"
                data-testid="social-twitter"
              >
                <Twitter size={18} />
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-['Montserrat'] text-sm font-semibold uppercase tracking-wider mb-4 text-[#DFAF3A]">
              Categorias
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/categoria/${encodeURIComponent(cat.slug)}`}
                    className="text-white/80 hover:text-[#DFAF3A] text-sm font-['Inter'] transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-['Montserrat'] text-sm font-semibold uppercase tracking-wider mb-4 text-[#DFAF3A]">
              Links Úteis
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/produtos" className="text-white/80 hover:text-[#DFAF3A] text-sm font-['Inter'] transition-colors">
                  Produtos Digitais
                </Link>
              </li>
              <li>
                <Link to="/servicos" className="text-white/80 hover:text-[#DFAF3A] text-sm font-['Inter'] transition-colors">
                  Serviços Recomendados
                </Link>
              </li>
              <li>
                <Link to="/sobre" className="text-white/80 hover:text-[#DFAF3A] text-sm font-['Inter'] transition-colors">
                  Sobre Nós
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-white/80 hover:text-[#DFAF3A] text-sm font-['Inter'] transition-colors">
                  Contato
                </Link>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-[#DFAF3A] text-sm font-['Inter'] transition-colors">
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-[#DFAF3A] text-sm font-['Inter'] transition-colors">
                  Termos de Uso
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Montserrat'] text-sm font-semibold uppercase tracking-wider mb-4 text-[#DFAF3A]">
              Contato
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-[#DFAF3A] mt-0.5" />
                <span className="text-white/80 text-sm font-['Inter']">
                  contato@portugalavista.com
                </span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#DFAF3A] mt-0.5" />
                <span className="text-white/80 text-sm font-['Inter']">
                  Lisboa, Portugal
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/20 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm font-['Inter']">
            © {new Date().getFullYear()} Portugal à Vista. Todos os direitos reservados.
          </p>
          <p className="text-white/80 text-xs font-['Inter']" data-testid="footer-tagline">
            Feito com <span className="text-[#E53935] inline-block" aria-label="amor">❤️</span> para a comunidade lusófona
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
